module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/ex-resort-c34ee55fa6375847b6c558c76ccdac50.png";